// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// function FormattedSummary({ summary }) {
//     return (
//       <div>
//         {summary.split("\n").map((line, index) => {
//           if (line.startsWith("•")) {
//             return (
//               <li key={index} style={{ marginLeft: "20px", listStyleType: "disc" }}>
//                 {line.substring(1).trim()}
//               </li>
//             );
//           } else if (line.startsWith("\t")) {
//             return (
//               <p key={index} style={{ marginLeft: "40px", }}>
//                 {line.trim()}
//               </p>
//             );
//           } else if (line.trim().length > 0) {
//             return (
//               <h4 key={index} style={{ marginTop: "20px", color: "#007bff" }}>
//                 {line.trim()}
//               </h4>
//             );
//           } else {
//             return <br key={index} />;
//           }
//         })}
//       </div>
//     );
//   }
  
//   export default FormattedSummary;


import React from "react";

function FormattedSummary({ summary }) {
  // Parse and format the summary
  const formatSummary = (summary) => {

    if (!summary) {
        return <p>Loading summary...</p>; // Fallback content if summary is undefined
    }


    return summary.split("\n").map((line, index) => {
      // Determine the level based on the number of "$" symbols
      const match = line.match(/^(\$+)\s*(.*)$/);
      if (!match) {
        return null; // Ignore lines that don't match the pattern
      }

      const level = match[1].length; // Number of "$" symbols
      const content = match[2].trim(); // Remove leading/trailing whitespace

      // Render based on the level
      const headingStyles = {
        1: { fontSize: "24px", fontWeight: "bold", marginTop: "20px", textAlign: "center", color: "#00008B", },
        2: { fontSize: "20px", fontWeight: "bold", marginTop: "15px", textAlign: "left", color: "#4169E1", },
        3: { fontSize: "18px", fontWeight: "normal", marginTop: "10px", textAlign: "left" },
        4: { fontSize: "16px", fontWeight: "normal", marginTop: "5px", textAlign: "left" },
        5: { fontSize: "14px", fontWeight: "normal", marginTop: "5px", textAlign: "left" },
        6: { fontSize: "12px", fontWeight: "normal", marginTop: "5px", textAlign: "left", color: "#555" }, 
        7: { fontSize: "10px", fontWeight: "lighter", marginTop: "5px", textAlign: "left", color: "#777" }, 
      };


        // Headings or paragraphs
        return (
          <div
            key={index}
            style={{
              marginLeft: `${level * 20}px`,
              ...headingStyles[level] || headingStyles[5], // Default to smallest style for unknown levels
            }}
          >
            {content}
          </div>
        );

    });
  };

  return <div>{formatSummary(summary)}</div>;
}

export default FormattedSummary;
